import View from "core/view";
import { HighscoreView, HighscoreUpdater } from "core/highscore";
import ExitByKeyController from "./controller/exitByKeyController";
export default function GameOverView(element) {
  const view = View({
    element
  });
  const thanks = element.querySelector("#gameOverThanks");
  const timeElement = element.querySelector(".value.time");
  const starsElement = element.querySelector(".stars");
  const starsTextElement = element.querySelector(".value.stars_text");
  const scoreElement = element.querySelector(".value.score");
  const highscoreUpdater = HighscoreUpdater(HighscoreView(view.querySelector(".highscore"), false));
  element.addEventListener("keydown", ExitByKeyController(view));
  function setTime(millis) {
    timeElement.innerHTML = millis;
  }
  function setStars(count, total) {
    starsTextElement.innerHTML = `${count} / ${total}`;
    Array.from(starsElement.children).forEach((element, index) => {
      if (index < count) element.classList.remove("grayed");else element.classList.add("grayed");
    });
  }
  function setScore(score) {
    scoreElement.innerHTML = score;
  }
  function setThanksVisible(visible) {
    if (visible) thanks.classList.remove("hidden");else thanks.classList.add("hidden");
  }
  async function updateHighscore(result) {
    await highscoreUpdater.update(result);
  }
  return Object.assign(view, {
    setThanksVisible,
    setTime,
    setStars,
    setScore,
    updateHighscore
  });
}